// B Corp certification facts and approved artwork.
// Source of truth: B Lab's brand book, brand.bcorp.com/visual-identity
// ("Logo application", updated 2026), plus the B Lab directory profile.
//
// The 2026 rules require every B Corp logo to direct to bcorp.com, via a
// hyperlink or "Learn more at bcorp.com" text. Every mark on the site
// hyperlinks to the directory profile below, which satisfies this (bcorp.com
// itself is B Lab's consumer short URL and redirects to bcorporation.net —
// there is no per-company profile path on bcorp.com). Internal storytelling
// links belong on surrounding text, never on the mark itself. Re-verify
// these values at recertification.

export const BCORP_PROFILE_URL =
  "https://www.bcorporation.net/en-us/find-a-b-corp/company/can-do-payments-ltd/";

// B Lab's consumer-facing short URL — the destination named by the 2026
// brand rules for "Learn more at bcorp.com" text links.
export const BCORP_COM_URL = "https://bcorp.com";

// Published by B Lab on the profile above — safe to quote in site copy.
export const BCORP_CERTIFIED = "June 2026";
export const BCORP_IMPACT_SCORE = "92.4";

// Official artwork, served unmodified from the brand CDN. Black on light,
// white on dark. The black SVG is the only vector variant published; there is
// no white SVG, so dark surfaces use the 404x680 PNG.
export const BCORP_BLACK_SVG =
  "https://cdn.candopayments.com/certifications/b-corp_black_web_solid.svg";
export const BCORP_WHITE_PNG =
  "https://cdn.candopayments.com/certifications/b-corp_white_web_transparent.png";

// Intrinsic dimensions, for width/height hints that prevent layout shift.
export const BCORP_BLACK_DIMS = { width: 137, height: 200 };
export const BCORP_WHITE_DIMS = { width: 404, height: 680 };
